export const load = () => ({
	h1: 'How To Install IndowONE Inserts',
	title: 'Tips For Installing Your Inserts And Safety Chains',
	description:
		'Ensure a snug fit and easy installation with our handy IndowONE installation guide.',
	showTitle: false,

	headerPosition: 'relative',
});
